import {
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { Property, SaleType } from 'src/app/models/property/property';
import { SwiperOptions } from 'swiper/types';
import { ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { HomeForRentService } from './../services/home-for-rent.service';
import { ResponsiveService } from 'src/app/core/ui/responsive/responsive.service';
import { PlatformService } from 'src/app/core/platform/platform.service';

@Component({
  selector: 'app-property-searches',
  templateUrl: './home-for-rent.component.html',
  styleUrls: ['./home-for-rent.component.css'],
  providers: [],
  encapsulation: ViewEncapsulation.None,
})
export class HomeForRentComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private HomeForRentService: HomeForRentService,
    protected titleService: Title,
    private metaService: Meta,
    private responsiveService: ResponsiveService,
    private platformService: PlatformService,
  ) { }


  ngOnInit(): void {
    const doc = this.responsiveService.getDocument()//TODO: change here
    if (doc && doc.scrollingElement) {
      doc.scrollingElement.scrollTop = 0;
    }

    this.activatedRoute.queryParams.subscribe((queryParams) => {
      this.titleService.setTitle('House, Apartment, Duplex, Condo, Vacant Land for Rent in Michigan');
      this.metaService.updateTag(
        { name: 'keywords', content: `Houses for Rent, Apartments for Rent, Duplex for Rent` }
      );
      this.metaService.updateTag(
        { name: 'description', content: `We have many Houses, Apartment, Duplex, Condo &amp; Vacant Land for Rent in Michigan. View listing photos and use our real estate detailed to find the perfect place.` }
      );
      this.status = queryParams.status;
      this.mode = queryParams.mode;
      this.is_search = queryParams.is_search;


      this.getHomeForRent();
    });

    // console.log(this.properties);
  }
  status: number = 1;
  mode: number = 2;
  is_search: number = 1;
  sidebar = false;


  data: string = `<p><b></p>`;
  // propertyByCities: { url_name: string, page_title: string }[] = PropertySearch;
  properties: Property[] = [];
  config1: SwiperOptions = {
    slidesPerView: 3,
    spaceBetween: 0,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    loop: true,
    pagination: { clickable: true },
    scrollbar: { draggable: false },
  };


  private getHomeForRent() {
    if (this.platformService.isPlatformBrowser) {
      this.HomeForRentService.getHomeForRent({
        is_search: 1,
        status: 1,
        mode: 2,
      }).subscribe((result) => {
        if (result.data.resultData) {
          this.properties = result.data.resultData.map((element: any) => {
            let thumbImg = element.PropertyImages[0];
            // console.log(element.address);
            element.PropertyImages.map((ele: any, i: number) => {
              if (ele.isThumb == 1) {
                thumbImg = ele;
              }
            });
            const details = {
              id: `${element.id}`,
              createdAt: new Date(`${element.createdAt}`).toISOString(),
              propertyType: (element.mode == 1) ? SaleType.ForSale : (element.mode == 2) ? SaleType.ForRent : (element.mode == 3) ? SaleType.ForRentAndSale : (element.mode == 4) ? SaleType.Deposite : SaleType.Deposite,
              title: element.place,
              price: (element.mode == 1) ? element.amount : (element.mode == 2) ? element.rent : (element.mode == 3) ? element.rent : (element.mode == 4) ? element.deposit : element.deposit,
              address: element.address,
              noOfBeds: element.PropertyBed ? element.PropertyBed.quantity : null,
              residenceType: element.PropertyType ? element.PropertyType.name : '',
              areaInSquareFt: element.area,
              noOfBaths: element.PropertyBath ? element.PropertyBath.quantity : null,
              image: `https://northbloomfield.s3.us-east-2.amazonaws.com/${thumbImg?.smallPath}`,
              // image: 'https://www.northbloomfield.com/img/main_images/small/991523175514169472.JPG',
              city: element.City ? element.City.name : '',
              place: element.place,
            };
            return new Property(
              details.id, details.createdAt, details.propertyType, details.title, details.price, details.address, details.noOfBeds, details.residenceType, details.areaInSquareFt, details.noOfBaths, details.image, details.city, details.place
            );
          });
        }
      });
    }
  }

  openFilterSearch(event: any) {
    this.sidebar = true

  };
  closeFilterSearch(event: any) {
    this.sidebar = false

  };
}
